import styled from 'styled-components';

export const StyledInputLabel = styled.span`
  margin-top: 20px;
  height: 18px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01px;
  line-height: 18px;
  margin-bottom: 10px;
`;

// type StyledInputProps = {
//   width: string;
//   disabled?: boolean;
// };
// /* disabled: ${(props) => props.disabled === true}; */
/* width: ${(props) => props.width || '100%'}; */
export const StyledInput = styled.input`
  /* box-sizing: border-box; */
  /* height: 50px; */
  /* width: 334px; */
  padding-left: 10px;
  background-color: transparent;
  border: none;
  text-align: right;

  &::placeholder {
    height: 19px;
    font-size: 16px;
    letter-spacing: 0.02px;
    line-height: 19px;
  }
`;
